import React from "react";
import { ModalContainer, MODAL_IDS } from "@west-tennessee-consulting/ui";
import { LinkCompanyModal } from "./LinkCompanyModal";
import type { LinkCompanyModalData } from "@/lib/modals/data/modal-data-types";

/**
 * Wrapper component for LinkCompanyModal that integrates with the global modal stack
 *
 * This component:
 * 1. Gets contactId, contactName, and current company info from modal context via ModalContainer
 * 2. Passes them to LinkCompanyModal
 * 3. Lets LinkCompanyModal handle all modal state and rendering
 */
export const LinkCompanyModalWrapper: React.FC = () => {
  return (
    <ModalContainer<LinkCompanyModalData> modalId={MODAL_IDS.contacts.linkCompany}>
      {({ isOpen, data, onClose }) => {
        const contactId = data?.contactId || "";
        const contactName = data?.contactName || "";
        const currentCompanyId = data?.currentCompanyId;
        const currentCompanyName = data?.currentCompanyName;

        return (
          <LinkCompanyModal
            contactId={contactId}
            contactName={contactName}
            currentCompanyId={currentCompanyId}
            currentCompanyName={currentCompanyName}
          />
        );
      }}
    </ModalContainer>
  );
};
